import { useRouter } from "@tanstack/react-router";
import { lazy, Suspense, useEffect } from "react";

import { LoginForm } from "../features/auth/LoginForm";
import { useLogout, useMe } from "../shared/hooks/useAuth";
const AuthenticatedWorkspace = lazy(() =>
  import("./AuthenticatedWorkspace").then((module) => ({
    default: module.AuthenticatedWorkspace,
  })),
);

export function AppRoot(): JSX.Element {
  const me = useMe();
  const logout = useLogout();
  const router = useRouter();

  useEffect(() => {
    if (!me.isLoading && !me.isFetching && !me.data) {
      router.navigate({ to: "/login" });
    }
  }, [me.isLoading, me.isFetching, me.data, router]);

  if (me.isLoading || !me.data) {
    return <div className="grid h-full place-items-center text-sm text-text-muted">Loading...</div>;
  }

  const onLogout = async () => {
    await logout.mutateAsync();
    router.navigate({ to: "/login" });
  };

  return (
    <Suspense
      fallback={
        <div className="grid h-full place-items-center text-sm text-text-muted">Loading...</div>
      }
    >
      <AuthenticatedWorkspace user={me.data} onLogout={onLogout} />
    </Suspense>
  );
}

export function LoginRoute(): JSX.Element {
  const router = useRouter();
  const me = useMe();

  useEffect(() => {
    if (me.data) {
      router.navigate({ to: "/" });
    }
  }, [me.data, router]);

  return (
    <div className="grid h-full place-items-center bg-bg">
      <LoginForm onSuccess={() => router.navigate({ to: "/" })} />
    </div>
  );
}
